import {_,Obscura} from '../../vendor';

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection';
import Resource from '../models/Resource';

const ResourcesProxy = Obscura.extend({

  getByContingent : function(conId) {
    return this.where({'contingent_id' : conId});
  },

});

export default InboomaBaseAsyncCollection.extend({
  
  collectionName : 'resources',
  model : Resource,
  url : '/resources',
  proxy : ResourcesProxy,

});